import { StyleSheet, View, ViewProps } from 'react-native';

import { spacing } from '@pletly/ui';

export const UsersContainer = ({ style, ...props }: ViewProps) => {
	return <View style={[styles.container, style]} {...props} />;
};

UsersContainer.Header = ({ style, ...props }: ViewProps) => (
	<View style={[styles.header, style]} {...props} />
);

const styles = StyleSheet.create({
	container: {
		gap: spacing(2),
	},
	header: { flexDirection: 'row', justifyContent: 'flex-end' },
});
